import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigRetailer";
import Constant from "../../constants";
import { FormattedMessage, IntlProvider } from "react-intl";
import { I18nPropvider, LOCALES } from "../../i18nProvider";
import translate from "../../i18nProvider/translate";
import RetailerCss from "../../public/css/retailer/retailer_style.css";
import RetailerHeader from "../retailer/RetailerHeader";
import RetailerSideMenu from "../retailer/RetailerSideMenu";
import Footer from "../patient/Patientfooter";
import { reactLocalStorage } from "reactjs-localstorage";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

export default class Retailertransactionhistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        vat: "",
        slabvalue: "",
        slabdiscount: "",
        deliverySlab: "",
        charges: "",
        set_delivery_days: "",
        email: "",
        userId: "",
        oldPassword: "",
        otp: "",
        newPassword: "",
        set_delivery_mode: "",
      },
      errors: {
        vat: "",
        discount_slab: "",
        discount: "",
        deliverySlab: "",
        charges: "",
        oldPassword: "",
        newPassword: "",
        set_delivery_mode: "",
      },
      logoUrl: "",
      bannerUrl: "",
    };
  }
  //   To get detais after first render

  componentDidMount = () => {
    let userData = ls.get("retuserObj");
    if (userData && userData.retailer_id) {
      this.setState({ retailerId: userData.retailer_id });
      this.getRetailerDetails(userData.retailer_id);
      this.fetchRetailerImages(userData.retailer_id);
    } else {
      window.location.href = "/retailer/login";
    }
  };

  // Add fetchRetailerImages method to class
  fetchRetailerImages = (retailerId) => {
    fetch(Constant.siteurl + "api/retailer/getRetailerImages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ retailer_id: retailerId }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success && result.data && result.data.length > 0) {
          this.setState({
            logoUrl: result.data[0].logo,
            bannerUrl: result.data[0].banner,
          });
          this.forceUpdate();
        }
      });
  };

  // Get the Retailer Details
  getRetailerDetails = (retailerId) => {
    Httpconfig.httptokenget(Constant.siteurl + "api/retailer/" + retailerId)
      .then((response) => {
        if ((response.data.status = 200)) {
          let fields = this.state.fields;

          fields["slabvalue"] = response.data.data[0].discount_slab;
          fields["slabdiscount"] = response.data.data[0].discount_type;
          fields["deliverySlab"] = response.data.data[0].set_delivery_type;
          fields["charges"] = response.data.data[0].set_delivery_slab;
          fields["GST"] = response.data.data[0].gst_type;
          fields["set_delivery_days"] = response.data.data[0].set_delivery_days;
          fields["email"] = response.data.data[0].tbl_user.email;
          fields["userId"] = response.data.data[0].user_id;
          fields["wallet_points"] = response.data.data[0].wallet_points;
          fields["set_delivery_mode"] = response.data.data[0].set_delivery_mode;

          this.setState({
            fields: fields,
          });

          this.forceUpdate();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // Update Vat Details
  saveRetailerDiscountDetails = (event) => {
    let retailerId = this.state.retailerId;
    let slabtype = this.state.fields.slabvalue;
    let discount = this.state.fields.slabdiscount;
    var errors = {};

    if (!Number(slabtype)) {
      errors["discount_slab"] = "Enter set slab";
      this.setState({ errors: errors });
    } else if (!Number(discount)) {
      errors["discount"] = "Enter discount";
      this.setState({ errors: errors });
    } else {
      this.setState({ errors: errors });
      Httpconfig.httptokenput(
        Constant.siteurl + "api/retailer/orderDiscountSlabUpdate/" + retailerId,
        {
          discount_type: discount,
          discount_slab: slabtype,
        }
      )
        .then((response) => {
          if ((response.data.status = 200 && !response.data.error)) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  // Update Discounts Details
  saveRetailerGstDetails = (event) => {
    let retailerId = this.state.retailerId;
    let gst = this.state.fields.GST || null;
    let errors = {};
    this.setState({ errors: errors });

    Httpconfig.httptokenput(
      Constant.siteurl + "api/retailer/taxUpdate/" + retailerId,
      { gst_type: gst }
    )
        .then((response) => {
          if ((response.data.status = 200 && !response.data.error)) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
  };

  // Handle delivery Mode
  handledeliverymode = (event) => {
    //alert(this.state.fields.set_delivery_mode)
    let retailerId = this.state.retailerId;
    let deliveryMode = this.state.fields.set_delivery_mode;

    if (deliveryMode == null && deliveryMode != "") {
      toast.error("Delivery mode should not be empty");
      return;
    }

    Httpconfig.httptokenput(
      Constant.siteurl + "api/retailer/SetOrderDeliveryDate/" + retailerId,
      {
        set_delivery_mode: deliveryMode,
      }
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          toast.success(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // Update Delivery Details
  saveDeliveryDeliveryDetails = (event) => {
    let retailerId = this.state.retailerId;
    let formError = false;
    let errors = {};
    if (
      this.state.fields.deliverySlab === "" ||
      this.state.fields.deliverySlab === null ||
      isNaN(Number(this.state.fields.deliverySlab))
    ) {
      formError = true;
      errors["deliverySlab"] = "Enter slab value";
      this.setState({ errors });
    }
    // if (!Number(this.state.fields.deliverySlab)) {
    //   formError = true;
    //   errors["deliverySlab"] = "Enter slab value";
    //   this.setState({ errors: errors });
    // }
    if (!Number(this.state.fields.charges)) {
      formError = true;
      errors["charges"] = "Enter charges";
      this.setState({ errors: errors });
    }

    // let vat=this.state.deliverySlab;
    if (!formError) {
      this.setState({ errors: errors });
      Httpconfig.httptokenput(
        Constant.siteurl +
          "api/retailer/setDeliveryChargesUpdate/" +
          retailerId,
        {
          set_delivery_type: this.state.fields.deliverySlab,
          set_delivery_slab: this.state.fields.charges,
        }
      )
        .then((response) => {
          if ((response.data.status = 200 && !response.data.error)) {
            toast.success(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };
  //  doe handle delivery date
  handledeliverydate = (event) => {
    let retailerId = this.state.retailerId;
    let deliverydate = $("#defaultdeliveryDate").val();

    if (deliverydate == "") {
      toast.error("delivery date should not be empty");
      return;
    }
    if (deliverydate > 9) {
      toast.error("delivery date should not more than 9 days");
      return;
    }
    Httpconfig.httptokenput(
      Constant.siteurl + "api/retailer/SetOrderDeliveryDate/" + retailerId,
      {
        set_delivery_days: this.state.set_delivery_date,
      }
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          toast.success(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  //  for handle delivery date value
  handleDeliveryDateValue = (event) => {
    let noDays = event.currentTarget.value;
    if (noDays > 9) {
      toast.error("Invalid Delivery days");
      $("#defaultdeliveryDate").val("");
      return;
    } else {
      this.state.set_delivery_date = noDays;
    }
  };
  //  for checking password
  checkPassword = () => {
    let formError = false;
    let errors = {};
    if (!this.state.fields.oldPassword) {
      formError = true;
      errors["oldPassword"] = "Enter old password";
      this.setState({ errors: errors });
    }
    if (!this.state.fields.newPassword) {
      formError = true;
      errors["newPassword"] = "Enter new password";
      this.setState({ errors: errors });
    } else if (
      this.state.fields.newPassword.length < 8 ||
      this.state.fields.newPassword.length > 20
    ) {
      formError = true;
      errors["newPassword"] = "Password shuold contain 8-20 characters";
      this.setState({ errors: errors });
    } else if (
      !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20}$/.exec(
        this.state.fields.newPassword
      )
    ) {
      formError = true;
      errors["newPassword"] =
        "Required one upper case, one small case, one number and one special character";
      this.setState({ errors: errors });
    }
    if (!formError) {
      this.setState({ errors: errors });
      Httpconfig.httptokenput(
        Constant.siteurl + "api/Users/user/verifyPassword",
        {
          userId: this.state.fields.userId,
          oldPassword: this.state.fields.oldPassword,
          email: this.state.fields.email,
        }
      )
        .then((response) => {
          if (response.data.status == 200 && !response.data.error)
            toast.success(response.data.message);
          else toast.error(response.data.message);
        })
        .catch((err) => {});
    }
  };

  //  for update password
  updatePassword = () => {
    Httpconfig.httptokenput(
      Constant.siteurl + "api/Users/user/updatePassword",
      {
        userId: this.state.fields.userId,
        otp: this.state.fields.otp,
        newPassword: this.state.fields.newPassword,
      }
    )
      .then((response) => {
        if (response.data.status == 200 && !response.data.error)
          toast.success(response.data.message);
        else toast.error(response.data.message);
      })
      .catch((err) => {});
  };

  // Add logo and banner upload fields (base64 conversion)
  handleFileToBase64 = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({ [type + "_base64"]: reader.result });
    };
    reader.readAsDataURL(file);
  };

  saveLogoBanner = () => {
    // Make logo and banner mandatory
    if (
      !this.state.logo_base64 &&
      !this.state.banner_base64 &&
      !this.state.logoUrl &&
      !this.state.bannerUrl
    ) {
      toast.error("Logo and Banner are mandatory. Please upload both images.");
      return;
    }

    const { logo_base64, banner_base64, logoUrl, bannerUrl } = this.state;

    // Check if Logo exists (either uploaded now or already saved)
    const hasLogo = logo_base64 || logoUrl;

    // Check if Banner exists (either uploaded now or already saved)
    const hasBanner = banner_base64 || bannerUrl;

    // Validation: require at least one of them
    if (!hasLogo && !hasBanner) {
      toast.error("Please upload at least one image — Logo or Banner.");
      return;
    }

    if (hasLogo && hasBanner) {
      //if (this.state.logo_base64 && this.state.banner_base64) {
      // Update logo and banner images
      fetch(Constant.siteurl + "api/retailer/updateretailerimages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          retailer_id: this.state.retailerId,
          logo: this.state.logo_base64,
          banner: this.state.banner_base64,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.success) {
            toast.success("Logo and Banner updated successfully!");
            this.setState({
              logoUrl: result.data.logo,
              bannerUrl: result.data.banner,
            });
          } else {
            toast.error("Failed to update logo/banner!");
          }
        })
        .catch(() => toast.error("Error updating logo/banner!"));
    } else {
      toast.success("Logo and Banner updated successfully!");
    }
  };

  render() {
    return (
      <main id="main">
        <RetailerHeader />
        <RetailerSideMenu />
        <section id="Pharmacy_dashboard">
          <div class="col-lg-10 col-md-10 Pharma_Content">
            <section id="ret_settings">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <div class="set_main">
                      <div class="set_head">
                        <h2>Set GST type</h2>
                      </div>
                      <div class="setting_box">
                        <div class="set_content">
                          <div class="set_form">
                            <div class="form-group">
                              <select
                                name="GST"
                                className="form-control"
                                value={this.state.fields.GST}
                                onChange={(event) => {
                                  this.setState({
                                    fields: { GST: event.target.value },
                                  });
                                }}
                              >
                                <option value="" disabled selected>
                                  Select GST
                                </option>
                                <option value="GST">GST(CGST + SGST)</option>
                                <option value="IGST">IGST</option>
                              </select>
                              <div className="cRed">
                                {this.state.errors["GST"]}
                              </div>
                            </div>

                            <div class="set_save_btn">
                              <button
                                type="button"
                                onClick={this.saveRetailerGstDetails}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="cRed">{this.state.errors["vat"]}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="set_main">
                      <div class="set_head">
                        <h2>Pharmacy Wallet Points</h2>
                      </div>
                      <div class="setting_box">
                        <div class="set_content">
                          <div class="set_form">
                            <div class="form-group">
                              <input
                                type="text"
                                class="form-control"
                                defaultValue={this.state.fields.wallet_points}
                                name="wallet_points"
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="set_main">
                      <div class="set_head">
                        <h2>Set Delivery Charges</h2>
                      </div>
                      <div class="setting_box">
                        <div class="set_content">
                          <div class="set_form">
                            <div class="form-group">
                              <select class="form-control">
                                <option>upto</option>
                              </select>
                            </div>

                            <div class="form-group">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Set Slab %"
                                defaultValue={this.state.fields.deliverySlab}
                                onKeyUp={(event) => {
                                  this.state.fields.deliverySlab =
                                    event.target.value;
                                }}
                                onKeyPress={(event) => {
                                  if (!/^[0-9]*$/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                              <div className="cRed">
                                {this.state.errors["deliverySlab"]}
                              </div>
                            </div>

                            <div class="form-group">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="₹ Charges"
                                defaultValue={this.state.fields.charges}
                                onKeyUp={(event) => {
                                  this.state.fields.charges =
                                    event.target.value;
                                }}
                                onKeyPress={(event) => {
                                  if (!/^[0-9]*$/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                              <div className="cRed">
                                {this.state.errors["charges"]}
                              </div>
                            </div>
                          </div>

                          <div class="set_delivery_btn">
                            <button
                              type="button"
                              onClick={this.saveDeliveryDeliveryDetails}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="set_main">
                      <div class="set_head">
                        <h2>Set Delivery Mode</h2>
                      </div>
                      <div class="setting_box">
                        <div class="set_content">
                          <div class="set_form">
                            <div class="form-group">
                              <select
                                class="form-control"
                                value={this.state.fields.set_delivery_mode}
                                onChange={(event) => {
                                  this.setState({
                                    fields: {
                                      set_delivery_mode: event.target.value,
                                    },
                                  });
                                }}
                              >
                                <option value="">Select</option>
                                <option value="Self">Self</option>
                                <option value="third party">Third Party</option>
                              </select>
                            </div>
                          </div>

                          <div class="set_delivery_btn">
                            <button
                              type="button"
                              onClick={this.handledeliverymode}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="set_main">
                      <div class="set_head">
                        <h2>Set Delivery Date</h2>
                      </div>
                      <div class="setting_box">
                        <div class="set_content">
                          <div class="set_form">
                            <div class="form-group">
                              <select class="form-control">
                                <option>Order date</option>
                              </select>
                            </div>

                            <div class="form-group">
                              <input
                                type="number"
                                class="form-control"
                                placeholder="1"
                                id="defaultdeliveryDate"
                                defaultValue={
                                  this.state.fields.set_delivery_days
                                }
                                maxLength={1}
                                onKeyPress={(event) => {
                                  if (!/^[0-9]*$/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                onKeyUp={this.handleDeliveryDateValue}
                              />
                            </div>
                          </div>

                          <div class="set_delivery_btn">
                            <button
                              type="button"
                              onClick={this.handledeliverydate}
                            >
                              Save
                            </button>
                          </div>
                          <div class="note_text">Note:Order date +1 day </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="set_main">
                      <div class="set_head">
                        <h2>Reset Password</h2>
                      </div>
                      <div class="setting_box">
                        <div class="set_content">
                          <div class="set_form">
                            <div class="form-group">
                              <input
                                type="Password"
                                class="form-control"
                                placeholder="Type Old Password"
                                onKeyUp={(event) => {
                                  this.state.fields.oldPassword =
                                    event.target.value;
                                }}
                              />
                              <div className="cRed">
                                {this.state.errors["oldPassword"]}
                              </div>
                            </div>

                            <div class="form-group">
                              <input
                                type="Password"
                                class="form-control"
                                placeholder="Type New Password"
                                onKeyUp={(event) => {
                                  this.state.fields.newPassword =
                                    event.target.value;
                                }}
                              />
                              <div className="cRed">
                                {this.state.errors["newPassword"]}
                              </div>
                            </div>

                            <div class="set_verify_btn">
                              <button
                                type="button"
                                onClick={this.checkPassword}
                              >
                                Verify
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="set_otp">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter OTP"
                              onKeyUp={(event) => {
                                this.state.fields.otp = event.target.value;
                              }}
                            />
                          </div>

                          <div class="resend_otp"></div>
                          <div class="set_verify_btn">
                            <button type="button" onClick={this.updatePassword}>
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Add logo and banner upload fields (base64 conversion) */}
                <div class="row">
                  <div class="col-md-12">
                    <div class="set_main">
                      <div class="set_head">
                        <h2>Upload Logo & Banner</h2>
                      </div>
                      <div class="setting_box">
                        <div
                          class="set_content"
                          style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
                        >
                          <div style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "flex-start" }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <label>Logo</label>
                              <div style={{ height: 90, display: "flex", alignItems: "center", marginBottom: 8, border: "1px solid #eee", borderRadius: 4, padding: 4, minWidth: 120 }}>
                                {this.state.logoUrl ? (
                                  <img
                                    src={this.state.logoUrl}
                                    alt="Retailer Logo"
                                    style={{ maxWidth: 120, maxHeight: 82, objectFit: "contain" }}
                                  />
                                ) : (
                                  <span style={{ color: "#bbb", fontSize: 12 }}>No image</span>
                                )}
                              </div>
                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={(e) =>
                                  this.handleFileToBase64(e, "logo")
                                }
                              />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <label>Banner</label>
                              <div style={{ height: 90, display: "flex", alignItems: "center", marginBottom: 8, border: "1px solid #eee", borderRadius: 4, padding: 4, minWidth: 240 }}>
                                {this.state.bannerUrl ? (
                                  <img
                                    src={this.state.bannerUrl}
                                    alt="Retailer Banner"
                                    style={{ maxWidth: 240, maxHeight: 82, objectFit: "contain" }}
                                  />
                                ) : (
                                  <span style={{ color: "#bbb", fontSize: 12 }}>No image</span>
                                )}
                              </div>
                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={(e) =>
                                  this.handleFileToBase64(e, "banner")
                                }
                              />
                            </div>
                          </div>
                          <div class="set_delivery_btn" style={{ marginTop: 12 }}>
                            <button
                              type="button"
                              onClick={this.saveLogoBanner}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <ToastContainer />
        </section>
      </main>
    );
  }
}
